import { useQuery } from "@apollo/client/react";

import { GET_FLOWS_INTEGRATION } from "./gql";

const useFlowsIntegration = () => {
  const { data, loading } = useQuery(GET_FLOWS_INTEGRATION);

  const flowsIntegration = data?.flowsIntegration;

  return {
    flowsIntegration,
    isLinked: !!flowsIntegration,
    loading,
  };
};

export default useFlowsIntegration;
